export function Scallop({ fill = "#ffffff", dir = "up", className = "" }) {
  const n = 24, w = 1440 / n;
  let d;
  if (dir === "up") {
    d = "M0 40 L0 20 ";
    for (let i = 0; i < n; i++) d += `Q ${i * w + w / 2} -2 ${(i + 1) * w} 20 `;
    d += "L1440 40 Z";
  } else {
    d = "M0 0 L0 20 ";
    for (let i = 0; i < n; i++) d += `Q ${i * w + w / 2} 42 ${(i + 1) * w} 20 `;
    d += "L1440 0 Z";
  }
  return (
    <svg viewBox="0 0 1440 40" preserveAspectRatio="none" aria-hidden="true"
      className={`block w-full h-9 ${dir === "up" ? "-mt-9 relative z-10" : "h-9"} ${className}`} style={{ marginBottom: dir === "up" ? "-1px" : undefined }}>
      <path d={d} fill={fill} />
    </svg>
  );
}

export function Heart({ className = "w-5 h-5", style }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={style} aria-hidden="true">
      <path d="M12 21s-7.5-4.9-10-9.2C.4 8.6 2 4.5 5.8 4.1c2.2-.2 4.2 1 5.2 2.7a6 6 0 0 1 5.2-2.7C20 4.5 21.6 8.6 20 11.8 17.5 16.1 12 21 12 21z" />
    </svg>
  );
}

export function Sparkle({ className = "w-5 h-5", style }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={style} aria-hidden="true">
      <path d="M12 2l1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8z" />
    </svg>
  );
}

export function Cloud({ className = "w-20 h-10", style }) {
  return (
    <svg viewBox="0 0 64 32" fill="currentColor" className={className} style={style} aria-hidden="true">
      <path d="M16 28c-6 0-10-4-10-9s4-9 9-9c1-5 6-8 11-6 3-4 10-4 13 1 5-1 10 3 10 8s-4 9-10 9H16z" />
    </svg>
  );
}
